import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './context/SessionContext';
import { ConsentBanner } from './components/ConsentBanner';
import { Footer } from './components/Footer';
import { captureAttribution } from './lib/attribution';
import { initTrustpilotLoader } from './lib/trustpilot';
import './styles/tokens.css';
import './styles/global.css';

// Capture click attribution (gclid + UTM params) on first visit (§12).
captureAttribution();

// Initialise the consent-gated Trustpilot loader (PECR Reg. 6 — the bootstrap
// script loads only after analytics consent is granted).
initTrustpilotLoader();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
        <ConsentBanner />
        <Footer />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);